export default {
    firstToCreate: 'Seien Sie der Erste, der ein Thema in diesem Forum erstellt',
    firstToPostInCategory: 'Seien Sie der Erste, der in dieser Kategorie postet',
    firstToRespondToTopic: 'Seien Sie der Erste, der auf dieses Thema antwortet!',
    createNewThread: 'Neues Thema erstellen',
    thread: 'Thema',
    viewThread: 'Thema anzeigen',
    replies: 'Antworten',
    noReplies: 'Keine Antworten',
    reply: 'Antwort',
    _reply: 'Antworten',
    ReplyTo: 'Antworten auf',
    replyToThisQuestion: 'Auf diese Frage antworten',
    onceRepliedModeratorMayRespond: 'Sobald Sie geantwortet haben, kann der Forummoderator auf Ihre Antwort reagieren',
    onceRepliedCanViewResponses: 'Sobald Sie geantwortet haben, können Sie die Antworten anderer Teilnehmer sehen',
    loadingResponses: 'Antworten werden geladen',
    hideXReplies: '{count} Antworten ausblenden',
    showXReplies: '{count} Antworten anzeigen',
    hideMostRecentReplies: 'Neueste Antworten ausblenden',
    showMostRecentReplies: 'Neueste Antworten anzeigen',
    post: 'Beitrag',
    message: 'Nachricht',
    typeMessage: 'Nachricht eingeben',
    addPost: 'Beitrag hinzufügen',
    addMessage: 'Nachricht hinzufügen',
    editPost: 'Beitrag bearbeiten',
    editPostWithMedia: 'Beitrag mit Medien bearbeiten',
    createPostWithMedia: 'Beitrag mit Medien erstellen',
    deleteMessage: 'Nachricht löschen',
    deleteMessageConfirm: 'Sind Sie sicher, dass Sie diese Nachricht löschen möchten?',
    pinPost: 'Beitrag anheften',
    media: 'Medien',
    uploadMedia: 'Medien hochladen',
    categories: 'Kategorien',
    goBack: 'Zurückgehen',
    goBackPrevious: 'Zurück zur vorherigen Seite',
    goBackToCategory: 'Zurück zur Kategorie {name}',
    loadingLatestThreads: 'Neueste Themen werden geladen',
    loadingDiscussionForum: 'Diskussionsforum wird geladen',
    dontShowAgainForTask: 'Für diese Aufgabe nicht mehr anzeigen',
    title: 'Titel',
    beTheFirst: 'Seien Sie der Erste, der auf diesen Thread antwortet'
};
